import { buildURL } from '../../helpers/urls';
import { get } from '../../helpers/fetch';

// eslint-disable-next-line import/prefer-default-export
export const fetchEvent = (slugDate) => {
  const url = buildURL(`/event/${slugDate}`);
  return get(url);
};
